export default Object.freeze({
    MODES: {
        WIDE: 'wide',
        COMPACT: 'compact',
    },
});
